import http from 'hub-http/clients/apiClient';
const BASE_URL = 'crm/v3/objects/contacts/search';
export const fetchContactCount = () => {
  return http.post(`${BASE_URL}`, {
    data: {
      limit: 1
    }
  });
};